import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Apireq } from '../models/apireq';
import { InfoService } from '../providers/info.service';
import { StoreService } from '../providers/store.service';
import * as jwt_decode from 'jwt-decode';

import { Router } from '@angular/router';


@Injectable()  
export class AuthService {
  //private apiUrl = 'http://tcsauth.eonmarks.de/';
  //private apiUrl = 'http://172.31.23.16/api/';
  //private apiUrl = 'http://localhost:3000/';
  private apiUrl = 'https://shell.ghp-tt.de/api/';  

  constructor(private router: Router, private http: HttpClient, private infoService: InfoService, private storeService: StoreService ) { }

 
  getDecodedToken(token: string): any {
      try { 
        return jwt_decode(token);   
      } catch (Error) {
        return null;
      }
    }

    login (apireq: Apireq) {
      this.infoService.setInfo({spinner: true});
      setTimeout(() => {
        this.infoService.setInfo({spinner: false});   
      }, 4000);

      const ret = {
        header: {},
        body: {}
      };


      return this.http.post<any>(
        this.apiUrl + apireq.url,
        apireq.param,
        {
          headers: new HttpHeaders(this.getHeader()),
          observe: 'response'
        }
      );
    }

    forgetpwd (apireq: Apireq) {
      this.infoService.setInfo({spinner: true});
      setTimeout(() => {
        this.infoService.setInfo({spinner: false});   
      }, 4000);

      const ret = {
        header: {},
        body: {}
      };

      return this.http.post<any>(
        this.apiUrl + apireq.url,
        apireq.param,
        {
          headers: new HttpHeaders(this.getHeader()),
          observe: 'response'
        }
      );
    }

    isAuth(): string {
      let iA = '/pages/login';

      const usr = this.storeService.getItem('user');
      if (usr && usr.token) {
        const jwt = this.getDecodedToken(usr.token);
        if (jwt) {
          const exp = parseInt(jwt.exp, 10);
          const dtm =  Math.floor( (new Date().getTime()) / 1000);
          if ((exp - dtm ) > 500) {
            iA = null;
            if (usr.fpwd === 1) {
              iA = '/admin/chgpwd';
            }
        }
      }
      //console.log(iA);

      return iA;
    }
  }

    logout(): void {
      this.storeService.removeItem('user');
      this.router.navigate(['/pages/login']);
    }

    setUser(user: any) {
      this.storeService.setItem('user', user );
    }

    getUser() {
      return this.storeService.getItem('user');
    }

    removeUser() {
      this.storeService.removeItem('user');
    }

    // setting the header auth
    getHeader () {
      const headerObj = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': '',
        };
      const usr = this.storeService.getItem('user'); 
      if (usr !== undefined) {
        // tbd
      }
      //console.log(headerObj);
      return headerObj;
    }

    // tbd on success
    handleSuccess (success: any) {
      this.infoService.setInfo({spinner: false});
      //console.log('Success in api service : ');
    }
 
    // tbd on error
    handleError (error: HttpErrorResponse) {
      this.infoService.setInfo({spinner: false});
      console.log('error in api service : ' + error.message);
    }

    // maybe there are things to do with every body ... so better use a service
    handleBody (body: any) {
      return body;
    }


}



// WEBPACK FOOTER //
// ./src/app/providers/auth.service.ts